// extracted by mini-css-extract-plugin
module.exports = {"spinner":"CircularButtonLoader_spinner_2tZ3B","spin":"CircularButtonLoader_spin_2p_u4"};